import React from 'react';
import moment from 'moment';
import { Field, submit } from 'redux-form';

import { TextField as TextFieldUI } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import EventIcon from '@material-ui/icons/Event';
import { KeyboardDatePicker } from '@material-ui/pickers';

import { DATE_FORMAT, TIME_FORMAT } from 'constants/config';

import { DatePickerModal } from './DatePickerModal';

const DateField = (props) => {
  const { meta, input, ...attrs } = props;

  const {
    dateType = 'datetime',
    InputProps = {},
    inputProps = {},
    disabled,
    clearable = true,
    helperText = '',
    label = '',
    submitOnChange,
    dateformat
  } = attrs;

  const error = meta.touched && meta.error;

  let df = DATE_FORMAT;
  if (dateType === 'datetime') {
    df = `${DATE_FORMAT}, ${TIME_FORMAT}`;
  } else if (dateType === 'time') {
    df = `${TIME_FORMAT}`;
  }
  if (dateformat) df = dateformat;

  const dispatch = meta.dispatch;
  const form = meta.form;

  const formatValue = (value) => {
    let res = null;
    if (value && dateType === 'time') {
      res = moment(value, [moment.ISO_8601, 'HH:mm:ss']);
    } else if (value) {
      res = moment(value);
    }
    return res;
  };

  const parseValue = (value) => {
    let res = null;
    if (value) {
      if (dateType === 'time') {
        res = value.second(0).format('HH:mm:ss');
      } else if (dateType === 'datetime') {
        res = value.second(0).toISOString();
      } else {
        res = value.endOf('day').toISOString();
      }
    }
    return res;
  };

  const _onChange = (date) => {
    let res = parseValue(date);
    input.onChange(res);
    setTimeout(() => {
      if (submitOnChange) dispatch(submit(form));
    }, 0);
  };

  const handleOpen = () => {
    if (disabled) return;
    setOpen(true);
  };

  const handleClose = () => {
    if (disabled) return;
    setOpen(false);
  };

  const value = formatValue(input.value || null);
  const inputValue = value ? value.format(df) : '';
  const [open, setOpen] = React.useState(false);
  const [pickerError, setPickerError] = React.useState(null);
  const [clearKey, setClearKey] = React.useState(0);

  const _onFocus = () => input.onFocus(input.value);
  const _onBlur = () => input.onBlur(input.value);

  if (dateType === 'date') {
    const handleKeyboardChange = (date, textValue) => {
      if (date === null || !textValue) {
        input.onChange(null);
        setPickerError(null);
        setClearKey((k) => k + 1);
        if (submitOnChange) setTimeout(() => dispatch(submit(form)), 0);
        return;
      }
      if (date.isValid()) {
        input.onChange(date.endOf('day').toISOString());
        setPickerError(null);
        if (submitOnChange) setTimeout(() => dispatch(submit(form)), 0);
      } else if (!textValue.includes('_')) {
        setPickerError('Неверный формат даты');
      }
    };

    return (
      <KeyboardDatePicker
        key={clearKey}
        fullWidth
        autoOk
        autoComplete="off"
        disabled={disabled}
        label={label}
        format={df}
        value={value}
        onChange={handleKeyboardChange}
        onFocus={_onFocus}
        onBlur={_onBlur}
        error={!!error || !!pickerError}
        helperText={error || pickerError || helperText || undefined}
        inputProps={{ maxLength: '1024', ...inputProps }}
        InputProps={InputProps}
        clearable={clearable}
        clearLabel="Сбросить"
        cancelLabel="Отмена"
        okLabel="Готово"
        invalidDateMessage=""
        keyboardIcon={<EventIcon fontSize="small" />}
        KeyboardButtonProps={{ style: { padding: 2 } }}
        InputAdornmentProps={{ style: { marginLeft: 0 } }}
      />
    );
  }

  return (
    <FormControl fullWidth error={!!error}>
      <div onClick={handleOpen}>
        <TextFieldUI
          fullWidth
          autoComplete="off"
          error={!!error}
          disabled={disabled}
          label={label}
          InputProps={{
            ...InputProps,
            endAdornment: <Adornment />
          }}
          inputProps={{
            maxLength: '1024',
            ...inputProps
          }}
          onFocus={_onFocus}
          onBlur={_onBlur}
          value={inputValue}
        />
      </div>
      <DatePickerModal
        isOpen={open}
        onChange={(v) => _onChange(v)}
        handleClose={handleClose}
        dateType={dateType}
        clearable={clearable}
        value={value}
      />
      {(error || helperText) && (
        <FormHelperText>{error || helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

const Adornment = () => (
  <InputAdornment position="end">
    <IconButton
      aria-label="calendar"
      tabIndex={-1}
      size="small"
      style={{ padding: 4 }}>
      <EventIcon fontSize="small" />
    </IconButton>
  </InputAdornment>
);

const FormDateField = (props) => {
  const { source, ...rest } = props;
  return <Field component={DateField} name={source} {...rest} />;
};

export default FormDateField;
